import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AttributeModule } from '../attribute/attribute.module';
import { ConfigBreadcrumbModule } from '../config-breadcrumb/config-breadcrumb.module';
import { ConfigurationComponent } from './configuration.component';
import { ConfigDetailComponent } from './config-detail.component';
import { ConfigMasterComponent } from './config-master.component';
import { ConfigTreeComponent } from './config-tree.component';
import { ConfigTreeNodeComponent } from './config-tree-node.component';
import { ResizableComponent } from '../Resizable/Resizable.component';
import { ConfigFilterComponent } from '../config-filter/config-filter.component';
//import { ConfigFilterAttributeComponent } from '../config-filter/config-filter-attribute.component';
import { ConfigFilterAttributePolymorphComponent } from '../config-filter/config-filter-attribute-polymorph.component';
import { ConfigHelpComponent } from '../config-help/config-help.component';
import { ConfigHelpAttributeComponent } from '../config-help/config-help-attribute.component';
import { ConfigActionComponent } from '../action/config-action.component';
import { ConfigActionInfoComponent } from '../action/config-action-info.component';
import { ConfigEventlogsComponent } from "../config-eventlogs/config-eventlogs.component";
import { ConfigEventlogsChildComponent } from "../config-eventlogs/config-eventlogs-child.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot(),
        AttributeModule,
        ConfigBreadcrumbModule
    ],
    declarations: [
        ConfigurationComponent,
        ConfigDetailComponent,
        ConfigMasterComponent,
        ConfigTreeComponent,
        ConfigTreeNodeComponent,
        ResizableComponent,
        ConfigFilterComponent,
        //ConfigFilterAttributeComponent,
        ConfigFilterAttributePolymorphComponent,
        ConfigHelpComponent,
        ConfigHelpAttributeComponent,
        ConfigActionComponent,
        ConfigActionInfoComponent,
        ConfigEventlogsComponent,
        ConfigEventlogsChildComponent
    ],
    providers: []
})
export class ConfigurationModule { }
